/* istanbul ignore file */
import { boolean as codecBoolean, optional as codecOptional } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const GetSessionSamlDataParser = /* #__PURE__ */ parsers.object([
    [
        'confirmSessionTermination',
        /* #__PURE__ */ codecOptional(codecBoolean),
        'confirm_session_termination',
    ],
]);
export class GetSessionSamlData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return GetSessionSamlDataParser.decode(input).map(res => new GetSessionSamlData(res));
    }
    static unsafeDecode(input) {
        return GetSessionSamlData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return GetSessionSamlDataParser.encode(data);
    }
    static schema() {
        return GetSessionSamlDataParser.schema();
    }
}
